module.exports = __webpack_public_path__ + "img/chart.fe802a08.svg";